import { useRef, useState } from 'react';
import { Box } from '@mui/material';

export const CarouselMobile = ({ children, disableButtonsInMobile = false, ...props }) => {
  const [activeStep, setActiveStep] = useState(0);
  const scrollRef = useRef(null);

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <Box
          ref={scrollRef}
          pb={1}
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
          {...props}
          onScroll={(e) => {
            const container = e.target;
            const firstChild = container.children[0];
            if (!firstChild) return;
            const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
            const childWidth = firstChild.offsetWidth + gap;
            const index = Math.round(container.scrollLeft / childWidth);
            if (index !== activeStep) {
              setActiveStep(index);
            }
          }}
        >
          {children.map((child, index) => (
            <Box
              key={index}
              sx={{
                maxWidth: { xs: '75%', sm: '45%', md: '33.33%' },
                scrollSnapAlign: 'start',
                flex: '0 0 75%',
                minWidth: { xs: '75%', sm: '45%', md: '33.33%' },
                paddingLeft: '24px',
                marginRight: index === children.length - 1 ? '24px' : '0',
              }}
            >
              {child}
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
